import { reducer as toastrReducer } from 'react-redux-toastr';
import { configurablePendingTasksReducer } from 'react-redux-spinner';

const authToken = () => sessionStorage.getItem('authToken') ?? '';

const initOptions = {
    headers: {
        Authorization: authToken(),
    }
};

const httpOptionsReducer = (options = initOptions, action) => {
    if (action.type === 'UPDATE_TOKEN') {
        return {
            ...options,
            Authorization: authToken(),
        }
    }
    return {
        headers: {
            Authorization: authToken(),
        }
    }
};

const pendingTasks = configurablePendingTasksReducer({ actionKeyPath: ['meta'] });

const coreReducers = {
    toastr: toastrReducer,
    pendingTasks,
    httpOptions: httpOptionsReducer,
};

export default coreReducers;
